export default function CsharpMath() {
  return (
    <h2>Csharp Math</h2>
  );
}
